import { BellRing } from "lucide-react";

/**
 * EntityAlertBadge — Wave 19 #84.
 *
 * Rose-red pulse with a count, used on JC + Ticket list rows when the
 * current user has unread directed notifications about the row's entity.
 * Different intent from <UnseenDot> (which is "new since you last looked
 * at the list") — this one means "there's something for YOU specifically."
 *
 * Renders nothing if count <= 0.
 */
export default function EntityAlertBadge({ count, testId, size = "sm" }) {
  if (!count || count <= 0) return null;
  const px = size === "lg" ? "px-2 py-0.5 text-[11px]" : "px-1.5 py-0.5 text-[10px]";
  const icon = size === "lg" ? "w-3 h-3" : "w-2.5 h-2.5";
  return (
    <span
      className={`relative inline-flex items-center gap-1 rounded-full font-bold tabular-nums border border-rose-400/60 bg-rose-500/20 text-rose-100 ${px}`}
      data-testid={testId || "entity-alert-badge"}
      title={`${count} new alert${count === 1 ? "" : "s"} for you`}
    >
      <span className="absolute inset-0 rounded-full bg-rose-500/30 animate-ping" aria-hidden />
      <BellRing className={`${icon} relative`} />
      <span className="relative">{count}</span>
    </span>
  );
}
